import React from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEnvelope,
  faUserPlus,
  faPhone,
  faArrowLeft,
  faSave,
  faBars,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'

export default function FormChrome({
  canAddItems,
  isPacienteCadastrado,
  allDisabled,
  mobileMenuOpen,
  onOpenMobileMenu,
  onCloseMobileMenu,
  onAddEmail,
  onAddDependentes,
  onAddTelefone,
  onHandleCancel,
}) {
  return (
    <>
      <div className="paciente-form-fab d-none d-md-flex" role="toolbar" aria-label="Ações do formulário">
        {canAddItems && (
          <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="fab-tip-save">{isPacienteCadastrado ? 'Salvar alterações' : 'Cadastrar paciente'}</Tooltip>}
          >
            <Button type="submit" variant="primary" className="paciente-form-fab-btn paciente-form-fab-btn--primary" aria-label={isPacienteCadastrado ? 'Salvar' : 'Cadastrar'}>
              <FontAwesomeIcon icon={faSave} />
            </Button>
          </OverlayTrigger>
        )}
        {canAddItems && (
          <OverlayTrigger placement="left" overlay={<Tooltip id="fab-tip-dep">Adicionar dependente</Tooltip>}>
            <Button
              type="button"
              variant="outline-primary"
              className="paciente-form-fab-btn paciente-form-fab-btn--light"
              onClick={onAddDependentes}
              aria-label="Adicionar dependente"
            >
              <FontAwesomeIcon icon={faUserPlus} />
            </Button>
          </OverlayTrigger>
        )}
        {canAddItems && (
          <OverlayTrigger placement="left" overlay={<Tooltip id="fab-tip-mail">Adicionar e-mail</Tooltip>}>
            <Button
              type="button"
              variant="outline-primary"
              className="paciente-form-fab-btn paciente-form-fab-btn--light"
              onClick={onAddEmail}
              aria-label="Adicionar e-mail"
            >
              <FontAwesomeIcon icon={faEnvelope} />
            </Button>
          </OverlayTrigger>
        )}
        {canAddItems && onAddTelefone && (
          <OverlayTrigger placement="left" overlay={<Tooltip id="fab-tip-tel">Adicionar telefone</Tooltip>}>
            <Button
              type="button"
              variant="outline-primary"
              className="paciente-form-fab-btn paciente-form-fab-btn--light"
              onClick={onAddTelefone}
              aria-label="Adicionar telefone"
            >
              <FontAwesomeIcon icon={faPhone} />
            </Button>
          </OverlayTrigger>
        )}
      </div>

      <div className="paciente-form-app-bar d-md-none fixed-bottom">
        <div className="paciente-form-app-bar__inner">
          <button
            type="button"
            className="paciente-form-app-btn"
            style={canAddItems ? {} : { flex: 1 }}
            onClick={onOpenMobileMenu}
            aria-haspopup="dialog"
            aria-expanded={mobileMenuOpen}
            aria-label="Abrir menu de opções"
          >
            <FontAwesomeIcon icon={faBars} />
            <span>Menu</span>
          </button>
          {canAddItems && (
            <>
              <div className="paciente-form-app-bar__vsep" aria-hidden="true" />
              <button type="submit" className="paciente-form-app-btn paciente-form-app-btn--primary" aria-label={isPacienteCadastrado ? 'Salvar' : 'Cadastrar'}>
                <FontAwesomeIcon icon={faSave} />
                <span>{isPacienteCadastrado ? 'Salvar' : 'Cadastrar'}</span>
              </button>
            </>
          )}
        </div>
      </div>

      <div
        className={`d-md-none paciente-form-mobile-drawer-root ${mobileMenuOpen ? 'paciente-form-mobile-drawer-root--open' : ''}`}
        aria-hidden={!mobileMenuOpen}
      >
        <button
          type="button"
          className="paciente-form-mobile-drawer-backdrop"
          aria-label="Fechar menu"
          onClick={onCloseMobileMenu}
          tabIndex={mobileMenuOpen ? 0 : -1}
        />
        <aside
          className="paciente-form-mobile-drawer"
          role="dialog"
          aria-modal={mobileMenuOpen}
          aria-labelledby="paciente-form-mobile-drawer-title"
          tabIndex={-1}
        >
          <div className="paciente-form-mobile-drawer__head">
            <h2 id="paciente-form-mobile-drawer-title" className="paciente-form-mobile-drawer__title">
              Mais opções
            </h2>
            <Button type="button" variant="link" className="p-0 text-secondary" onClick={onCloseMobileMenu} aria-label="Fechar">
              <FontAwesomeIcon icon={faTimes} size="lg" />
            </Button>
          </div>
          <div className="paciente-form-mobile-drawer__body">
            <button
              type="button"
              className="paciente-form-mobile-drawer__item"
              onClick={() => {
                onCloseMobileMenu()
                onHandleCancel()
              }}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              {allDisabled || isPacienteCadastrado ? 'Voltar' : 'Cancelar'}
            </button>
            {canAddItems && (
              <>
                <button
                  type="button"
                  className="paciente-form-mobile-drawer__item"
                  onClick={() => {
                    onCloseMobileMenu()
                    onAddEmail()
                  }}
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                  Adicionar e-mail
                </button>
                <button
                  type="button"
                  className="paciente-form-mobile-drawer__item"
                  onClick={() => {
                    onCloseMobileMenu()
                    onAddDependentes()
                  }}
                >
                  <FontAwesomeIcon icon={faUserPlus} />
                  Adicionar dependente
                </button>
                {onAddTelefone && (
                  <button
                    type="button"
                    className="paciente-form-mobile-drawer__item"
                    onClick={() => {
                      onCloseMobileMenu()
                      onAddTelefone()
                    }}
                  >
                    <FontAwesomeIcon icon={faPhone} />
                    Adicionar telefone
                  </button>
                )}
              </>
            )}
          </div>
        </aside>
      </div>
    </>
  )
}
